import { ChargingCardModel } from '../../charging-cards/api/models/charging-card-model'
import { CardStatus } from '../../shared'

export const MOCK_CHARGING_CARD_TO_BE_EDITED: ChargingCardModel = {
  cardName: 'Test card 1',
  changedAt: '2023-03-20T12:35:42',
  createdAt: '2022-11-22T09:30:09',
  description: 'Test card 1 details',
  expirationDate: null,
  installationId: 9476,
  ocpiTokenId: '2ca00a8f-e5fd-4cb9-b5bf-50c095f2326c',
  tokenId: 'J',
  user: '',
  userId: '',
  status: CardStatus.active,
  linkedWallboxes: [],
}
